module.exports = __webpack_public_path__ + "static/img/blz.2de8b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/blz.png
// module id = UrgU
// module chunks = 18